import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'

import './styles.scss'

export const ErrorMessage: FC<{ children: ReactNode }> = ({ children }) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  return <div className={`ui-error ${whiteLabel}`}>{children}</div>
}
